module.exports = __webpack_public_path__ + "img/img40.5d124f5a.png";